const rules = {
  fnameRules: [
    v => !!v || "First name is required",
    v =>
      (v && /^[_A-z]*((-|\s)*[_A-z])*$/.test(v)) ||
      "First name must only contain letters"
  ],
  lnameRules: [
    v => !!v || "Last name is required",
    v =>
      (v && /^[_A-z]*((-|\s)*[_A-z])*$/.test(v)) ||
      "Last name must only contain letters"
  ],
  postalCodeRules: [
    v => !!v || "Postal code is required",
    v => (v && /^\d+$/.test(v)) || "Postal code must only contain numbers",
    v => (v && v.length === 5) || "Postal code must be exactly 5 characters"
  ],
  phoneRules: [
    v => {
      if (v)
        return (
          (v && /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(v)) ||
          "Phone number must be valid"
        );
      else return true;
    },
    v => {
      if (v)
        return (
          (v && v.length >= 10) ||
          "Phone number must contain at least 10 characters"
        );
      else return true;
    }
  ]
};

export default {
  rules
};
